import { FC } from 'react';

import { EMessageRole, TMessage } from '@/hooks/promptCanvas/types';

const UserMessage = ({ content }: { content: string }) => {
  return (
    <div className="flex flex-row justify-end gap-2 p-2">
      <div className="max-w-[75%] break-words rounded-lg bg-brand-primary px-3 py-2 text-sm text-white">
        {content}
      </div>
    </div>
  );
};

const AIMessage = ({ content }: { content: string }) => {
  return (
    <div className="flex w-full flex-row gap-2 p-2">
      <div className="max-w-[75%] break-words rounded-lg bg-secondary-hover px-3 py-2 text-sm text-secondary">
        {content}
      </div>
    </div>
  );
};

type TProps = {
  message: TMessage;
};

const Message: FC<TProps> = ({ message }) => {
  switch (message.type) {
    case EMessageRole.USER:
      return <UserMessage content={message.content} />;
    case EMessageRole.AI:
      return <AIMessage content={message.content} />;
  }
};

export default Message;
